/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:28/07/2021
 @Time:10:48
 **/
export default class Langue {

    /**
     * @type{String}
     */
    #id;

    /**
     * @type{String}
     */
    #langue;

    /**
     * @type{String}
     */
    #locale;

    /**
     * @type{String}
     */
    #pays;

    /**
     *
     * @param {string} id
     * @param {string} langue
     * @param {string} pays
     */
    constructor(id, langue, pays,locale) {
        this.#id = id;
        this.#pays = pays;
        this.#langue=langue;
        this.#locale=locale;
    }


    /**
     *
     * @param {string} id
     */
    set id(id) {
        this.#id = id;
    }

    /**
     *
     * @returns {string}
     */
    get id() {
        return this.#id;
    }

    /**
     *
     * @param {string} langue
     */
    set langue(langue) {
        this.#langue = langue;
        this.#setLocale();
    }

    /**
     *
     * @returns {string}
     */
    get langue() {
        return this.#langue;
    }

    #setLocale() {
        this.#locale = this.#langue + "_" + this.#pays;
    }

    /**
     *
     * @param {string} pays
     */
    set pays(pays) {
        this.#pays = pays;
        this.#setLocale();
    }

    /**
     *
     * @returns {string}
     */
    get pays() {
        return this.#pays;
    }

    /**
     * méthode qui retourne la locale
     * @returns {string}
     */
    get locale() {
        /**
         *
         * @type {string}
         * @private
         */
        return this.#locale;
    }


    /**
     * Méthode qui permet de créer langues disponible dans begro
     * @param {Langue[]} langues
     */
    static createLanguesFromJsonArray(languesJSON) {
        let langues = [];
        for (let i in languesJSON) {
            let langueJSON = languesJSON[i];
            langues.push(new Langue(langueJSON.id, langueJSON.langue, langueJSON.pays,langueJSON.locale));
        }
        return langues
    }

    /**
     *
     * @return {string} return locale js format exemple fr-FR
     */
    getLocaleJsFormat() {
        return this.#locale.replace("_", "-");
    }


}